(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-lp-share]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var data = { title: btn.getAttribute('data-title'), url: btn.getAttribute('data-url') };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
        return;
      }
      var label = btn.querySelector('[data-lp-share-label]');
      var done = function () {
        if (!label) return;
        var old = label.textContent;
        label.textContent = 'Link copied';
        setTimeout(function () { label.textContent = old; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(data.url).then(done).catch(done);
      } else {
        window.prompt('Copy this link', data.url);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipes-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.lp-recipes');
    if (!root) return;

    var filters = root.querySelector('[data-lp-filters]');
    var toggle = root.querySelector('[data-lp-filters-toggle]');
    if (filters && toggle) {
      toggle.addEventListener('click', function () {
        var open = filters.getAttribute('data-open') === 'true';
        filters.setAttribute('data-open', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }

    var btn = root.querySelector('[data-lp-loadmore]');
    var grid = root.querySelector('[data-lp-grid]');
    if (btn && grid) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('href');
        if (!url) return;
        btn.setAttribute('aria-busy', 'true');
        fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('[data-lp-grid] .lp-card');
            cards.forEach(function (c) { grid.appendChild(c); });
            var next = doc.querySelector('[data-lp-loadmore]');
            if (next && next.getAttribute('href')) {
              btn.setAttribute('href', next.getAttribute('href'));
              btn.removeAttribute('aria-busy');
            } else {
              btn.parentNode.removeChild(btn);
            }
            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, '', url);
            }
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            window.location.href = url;
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
